// SSR-safe ticking clock. Returns a `Date` that advances every `intervalMs`,
// used by the auto-clockout countdown banner. The first render (SSR + initial
// client render) returns a single fixed instant captured at mount so server and
// client markup match; the interval only starts in an effect, after mount —
// mirroring the `is_mounted` hydration discipline in live-in-club-page.tsx.
//
// Consumers should still gate zone/now-sensitive rendering on their own mount
// flag; this hook keeps the *value* stable across hydration but the banner
// decides *whether* to show a countdown at all.

import { useEffect, useState } from 'react';

export function useNow(intervalMs = 60_000): Date {
	const [now, setNow] = useState(() => new Date());

	useEffect(() => {
		const id = setInterval(() => setNow(new Date()), intervalMs);
		return () => clearInterval(id);
	}, [intervalMs]);

	return now;
}
